import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import {
  Wrapper,
  Heading,
  Message,
  Button,
  ImageWrapper
} from './CheckoutErrorMessageStyledComponents'
import CashoutError from '../../../assets/images/cashout_error.png'

const messagesSwitch = error => {
  if (error.extensions) {
    switch (error.extensions.code) {
      case 'payee_account_locked_or_closed': {
        return (
          <React.Fragment key={error.extensions.code}>
            <Heading>
              <FormattedMessage id='checkoutError.payeeAccountLockedTitle' />
            </Heading>
            <Message>
              <FormattedMessage id='checkoutError.payeeAccountLockedDescription' />
            </Message>
          </React.Fragment>
        )
      }
      default: {
        return (
          <React.Fragment key='default_checkout_error'>
            <Heading>
              <FormattedMessage id='checkoutError.error' />
            </Heading>
            <Message>
              <FormattedMessage id='checkoutError.description' />
            </Message>
          </React.Fragment>
        )
      }
    }
  } else return null
}

const CheckoutErrorMessage = React.memo(({ checkoutErrors, toggleModal }) => (
  <Wrapper>
    <ImageWrapper>
      <img src={CashoutError} alt='' />
    </ImageWrapper>
    {checkoutErrors.map(error => messagesSwitch(error))}
    <Button color='primary' onClick={() => toggleModal()}>
      <FormattedMessage id='checkoutError.goBackToStore' />
    </Button>
  </Wrapper>
))

CheckoutErrorMessage.displayName = 'CheckoutErrorMessage'

CheckoutErrorMessage.propTypes = {
  checkoutErrors: PropTypes.any,
  toggleModal: PropTypes.func
}

export default CheckoutErrorMessage
